import { useGetContext } from '../../api/lendingApi/lendingApiQueries';
import { useCookieConsent } from '../../hooks/useCookieConsent';
import { useLocale } from '../../hooks/useLocale';
import { getRuntimeEnvironment } from '../../utils/getRuntimeEnvironment';

export const useCanBootIntercom = () => {
  const { context, isContextLoading } = useGetContext();
  const { isUK } = useLocale();
  const hasFunctionalConsent = useCookieConsent('C0003');

  // OneTrust only loads in production, so there is no consent to wait for
  // anywhere else.
  const isConsentSatisfied =
    getRuntimeEnvironment() !== 'production' || hasFunctionalConsent;

  return (
    isUK &&
    !isContextLoading &&
    context?.logged_in_user_type !== 'staff' &&
    isConsentSatisfied
  );
};
